// import AlertMixin from './alert'
// import ToastAlertMixin from './toast-alert'
// import ScrollerMixin from './scroller'
// import DatesMixin from './dates'
// import PagesMixin from './pages'
// import AuthMixin from './auth'
// import LocationMixin from './location'
import ServiceMixin from './service'
import StorageMixin from './storage'
// import DesignerMixin from '../designer/mixins'

export default {
  mixins: [
    // AlertMixin,
    // ToastAlertMixin,
    // ScrollerMixin,
    // DatesMixin,
    // PagesMixin,
    // AuthMixin,
    // LocationMixin,
    ServiceMixin,
    StorageMixin,
    // DesignerMixin
  ],
  data() {
    return {
      //
    }
  },
  computed: {
  },
}

